<dx-popup
  [(visible)]="visible"
  [showTitle]="false"
  [showCloseButton]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [width]="'min(720px, 95vw)'"
  [height]="'auto'"
  [maxHeight]="'90vh'"
  [wrapperAttr]="{ class: 'registration-flow-onboarding-popup' }"
>
  <div *dxTemplate="let data of 'content'">
    <div class="onboarding-modal">

      <!-- Progress indicator -->
      <div class="fm-steps">
        <span *ngFor="let step of steps" class="fm-step">
          <i
            class="fm-step-bar"
            [class.fm-step-bar-done]="stepNumber > step.number"
            [class.fm-step-bar-active]="stepNumber === step.number"
          ></i>

          <em
            class="fm-step-label"
            [class.fm-step-label-done]="stepNumber > step.number"
            [class.fm-step-label-active]="stepNumber === step.number"
          >
            {{ step.number }} · {{ step.translationKey | translate }}
          </em>
        </span>
      </div>

      <!-- Step 1: Profile questions -->
      <ng-container *ngIf="currentStep === 'questions'">
        <div class="onboarding-scroll">
          <div class="onboarding-title">
            {{ 'REGISTRATION-FLOW.ONBOARDING.PROFILE.TITLE' | translate: { name: firstName } }}
          </div>

          <div class="onboarding-subtitle">
            {{ 'REGISTRATION-FLOW.ONBOARDING.PROFILE.DESCRIPTION' | translate }}
          </div>

          <div
            class="onboarding-invited-by"
            *ngIf="
              isInvitedEmployee &&
              pendingRegistrationFlow &&
              pendingRegistrationFlow.createdByPerson as createdByPerson
            "
          >
            <div class="person-avatar">
              <img
                *ngIf="createdByPerson.imageFile?.fileUrl; else initials"
                [src]="createdByPerson.imageFile!.fileUrl"
                [alt]="createdByPerson.firstName"
              />

              <ng-template #initials>
                <span>{{ createdByPerson.firstName[0] }}{{ createdByPerson.lastName[0] }}</span>
              </ng-template>
            </div>

            <span
              [innerHTML]="
                'REGISTRATION-FLOW.ONBOARDING.PROFILE.INVITED-EMPLOYEE-ADDED-BY'
                  | translate: {
                      createdBy: createdByPerson.firstName + ' ' + createdByPerson.lastName,
                      companyName: pendingRegistrationFlow.companyName
                    }
              "
            ></span>
          </div>

          <div class="questions">
            <div
              *ngFor="let question of questions"
              class="question"
              [class.invalid]="errors[question.id]"
            >
              <div class="question-title">
                {{ question.text }}

                <span *ngIf="question.isRequired" class="required">*</span>

                <span *ngIf="!question.isRequired" class="optional">
                  ({{ 'COMMON.OPTIONAL' | translate }})
                </span>
              </div>

              <div *ngIf="question.hint" class="hint">
                {{ question.hint }}
              </div>

              <!-- Text -->
              <dx-text-box
                *ngIf="question.type === questionType.Text"
                [value]="getTextAnswer(question.id)"
                [placeholder]="'REGISTRATION-FLOW.ONBOARDING.PROFILE.ANSWER-PLACEHOLDER' | translate"
                valueChangeEvent="input"
                [disabled]="isSaving"
                (onValueChanged)="setAnswer(question.id, $event.value)"
              ></dx-text-box>

              <!-- Yes / No -->
              <div
                *ngIf="question.type === questionType.YesNo"
                class="answer-options"
              >
                <dx-radio-group
                  [items]="question.options"
                  displayExpr="text"
                  valueExpr="id"
                  [value]="answers[question.id]"
                  [disabled]="isSaving"
                  (onValueChanged)="setAnswer(question.id, $event.value)"
                  layout="vertical"
                ></dx-radio-group>
              </div>

              <!-- Single choice -->
              <div
                *ngIf="question.type === questionType.SingleChoice"
                class="answer-options"
              >
                <dx-radio-group
                  [items]="question.options"
                  displayExpr="text"
                  valueExpr="id"
                  [value]="answers[question.id]"
                  [disabled]="isSaving"
                  (onValueChanged)="setAnswer(question.id, $event.value)"
                  layout="vertical"
                ></dx-radio-group>
              </div>

              <!-- Multiple choice -->
              <div
                *ngIf="question.type === questionType.MultipleChoice"
                class="answer-options"
              >
                <dx-check-box
                  *ngFor="let option of question.options"
                  [text]="option.text"
                  [value]="isSelected(question.id, option.id)"
                  [disabled]="isSaving"
                  (onValueChanged)="toggleOption(question.id, option.id, $event.value)"
                ></dx-check-box>
              </div>

              <p *ngIf="errors[question.id]" class="error-message">
                {{ 'REGISTRATION-FLOW.ONBOARDING.VALIDATION.REQUIRED-QUESTION' | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="actions">
          <span></span>

          <dx-button
            [text]="'COMMON.NEXT' | translate"
            type="normal"
            [disabled]="isSaving"
            (onClick)="next()"
          ></dx-button>
        </div>
      </ng-container>

      <!-- Step 2: Invite team members -->
      <ng-container *ngIf="currentStep === 'employees'">
        <dx-scroll-view
          class="onboarding-scroll"
          [useNative]="true"
          direction="vertical"
          [showScrollbar]="'always'"
          [height]="'auto'"
        >
          <h2 class="onboarding-title">
            {{ 'REGISTRATION-FLOW.ONBOARDING.TEAM.TITLE' | translate }}
          </h2>

          <p class="onboarding-subtitle">
            {{ 'REGISTRATION-FLOW.ONBOARDING.TEAM.DESCRIPTION' | translate }}
          </p>

          <div class="team-members">
            <div
              *ngFor="let person of teamMembers; let i = index"
              class="team-member-row"
            >
              <dx-text-box
                [value]="person.firstName"
                [placeholder]="'COMMON.FIELDS.FIRST-NAME' | translate"
                valueChangeEvent="input"
                [disabled]="isSaving"
                (onValueChanged)="person.firstName = $event.value"
              ></dx-text-box>

              <dx-text-box
                [value]="person.lastName"
                [placeholder]="'COMMON.FIELDS.LAST-NAME' | translate"
                valueChangeEvent="input"
                [disabled]="isSaving"
                (onValueChanged)="person.lastName = $event.value"
              ></dx-text-box>

              <dx-text-box
                class="team-member-email"
                [value]="person.email"
                [placeholder]="'COMMON.FIELDS.EMAIL' | translate"
                valueChangeEvent="input"
                [disabled]="isSaving"
                (onValueChanged)="person.email = $event.value"
              ></dx-text-box>

              <dx-button
                icon="close"
                stylingMode="text"
                type="danger"
                [disabled]="isSaving"
                [elementAttr]="{ class: 'team-member-remove' }"
                [hint]="'REGISTRATION-FLOW.ONBOARDING.TEAM.REMOVE-PERSON' | translate"
                (onClick)="removePerson(i)"
              ></dx-button>

              <p
                *ngIf="teamMemberErrors[i]"
                class="error-message team-member-error"
              >
                {{ teamMemberErrors[i] | translate }}
              </p>
            </div>
          </div>

          <dx-button
            [text]="'REGISTRATION-FLOW.ONBOARDING.TEAM.ADD-PERSON' | translate"
            icon="plus"
            type="default"
            [disabled]="isSaving"
            (onClick)="addPerson()"
          ></dx-button>

          <div class="team-invitation-note">
            <span class="info">
              <i
                class="dx-icon dx-svg-icon"
                [innerHTML]="getMailIcon()"
              ></i>
            </span>

            <span
              [innerHTML]="'REGISTRATION-FLOW.ONBOARDING.TEAM.INVITATION-NOTE' | translate"
            ></span>
          </div>
        </dx-scroll-view>

        <div class="actions">
          <dx-button
            [text]="'COMMON.BACK' | translate"
            type="default"
            [disabled]="isSaving"
            (onClick)="back()"
          ></dx-button>

          <div class="forward-actions">
            <dx-button
              [text]="'COMMON.SKIP' | translate"
              type="default"
              [disabled]="isSaving"
              (onClick)="skipEmployees()"
            ></dx-button>

            <dx-button
              [text]="'COMMON.NEXT' | translate"
              type="normal"
              [disabled]="isSaving"
              (onClick)="next()"
            ></dx-button>
          </div>
        </div>
      </ng-container>

      <!-- Step 3: Completion -->
      <ng-container *ngIf="currentStep === 'complete'">
        <div class="completion-content">
          <div class="completion-icon">
            <i class="dx-icon dx-icon-check"></i>
          </div>

          <h2 class="onboarding-title completion-title">
            {{ 'REGISTRATION-FLOW.ONBOARDING.COMPLETE.TITLE' | translate }}
          </h2>

          <p class="onboarding-subtitle completion-description">
            {{ 'REGISTRATION-FLOW.ONBOARDING.COMPLETE.DESCRIPTION' | translate }}
          </p>
        </div>

        <div class="actions">
          <dx-button
            [text]="'COMMON.BACK' | translate"
            type="default"
            [disabled]="isSaving"
            (onClick)="back()"
          ></dx-button>

          <dx-button
            [text]="'COMMON.GET-STARTED' | translate"
            type="normal"
            [disabled]="isSaving"
            [icon]="isSaving ? 'refresh' : ''"
            (onClick)="finish()"
          ></dx-button>
        </div>
      </ng-container>

    </div>
  </div>
</dx-popup>